import { http } from '@/utils/http.js';

export const GlobalApi = {
  getCurrentUser() {
    return http.get('/api/users/current').then((response) => response.data.data);
  },

  updateCurrentUser(data) {
    return http.patch('/api/users/current', data).then((response) => response.data.data);
  },

  getUserEmail(email) {
    return http.get('/api/users/lookups/email', { params: { email } }).then((response) => response.data);
  },

  getTimezones() {
    return http.get('/api/locations/timezones').then((response) => {
      return response.data;
    });
  },
};
